import t from"./_nativeCreate.js";var a=t;var e=function(){this.__data__=a?a(null):{},this.size=0};export{e as default};
//# sourceMappingURL=_hashClear.js.map
